import { List, ListItemButton, ListItem, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

import colors from "theme/themeConstants";
import { routes } from "routes";

interface ITopics {
  [code: string]: string;
}

const TOPICS: ITopics = {
  gifs: "GIFs",
  images: "Images",
  creators: "Creators",
  niches: "Niches",
};

export const TopicSelector = (props: {
  active: string;
}) => {
  const topics = TOPICS;
  const navigate = useNavigate();

  const onClick = (code: string) => () => {
    if (code === "gifs") {
      navigate(routes.exploreTop());
    } else if (code === "images") {
      navigate(routes.exploreImages());
    } else if (code === "creators") {
      navigate(routes.exploreCreators());
    } else {
      navigate(routes.niches());
    }
  };

  return (
    <List
      className="topicSelector"
      component="nav"
      sx={{
        position: "relative",
        display: "flex",
        height: "60px",
        alignItems: "center",
        padding: 0,
        width: "100%",
        overscrollBehavior: "contain",
        msOverflowStyle: "none",
        scrollbarWidth: "0 !important",
        overflowX: "hidden",
        "::-webkit-scrollbar": {
          display: "none",
        }
      }}

    >
      {Object.keys(topics).map((topic, index) => {
        return (
          <StyledListItem onClick={onClick(topic)} key={topic} sx={{
            div: { width: "max-content" },
          }} isCurrentTopic={topic === props.active} >
            <ListItemButton sx={{ padding: 0 }}>{topics[topic]}</ListItemButton>
          </StyledListItem>
        );
      })}
    </List>
  );
};

const StyledListItem = styled(ListItem,
  { shouldForwardProp: (prop) => prop !== "isCurrentTopic" }
)<{ isCurrentTopic: boolean }>(({ isCurrentTopic }) => {
  return {
    flexDirection: "column",
    display: "relative",
    color: colors.white,
    opacity: isCurrentTopic ? "1" : "0.5",
    transition: "opacity .3s ease",

    "&:hover": {
      opacity: isCurrentTopic ? "1" : "0.8"
    },

    "&::after": isCurrentTopic ? {
      // eslint-disable-next-line
      content: '""',
      width: "18px",
      height: "2px",
      top: "8px",
      background: colors.purpleGradient,
      borderRadius: "25px",
    } : {}
  };
});
